export enum SignalRAction {
  RETRIEVE_ORDER = "SIGNALR_RETRIEVE_ORDER",
  RETURN_ORDER = "SIGNALR_RETURN_ORDER",
}
